import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AgentService } from '../../../shared/_services/agent.service';
import { OfficeService } from '../../../shared/_services/office.service';
import { Agent, MissingData } from './../../../shared/models/missingdata.model';
import { Office } from './../../../shared/models/missingdata.model';
import { FileService } from '../../../shared/_services/file.service';
//import { Agent } from '@models/missingdata.model';

@Component({
  selector: 'app-fill-agents',
  templateUrl: './fill-agents.component.html',
  styleUrls: ['./fill-agents.component.css']
})
export class FillAgentsComponent implements OnInit {

  agentList: Agent[];
  offices: Office[];
  btnText: string = "Finalizar";


  constructor(
    private agentService: AgentService,
    private officeService: OfficeService,
    private fileService: FileService,
    private router: Router
  ) {}

  ngOnInit() {
    this.fileService.getMissingData()
      .subscribe((res: MissingData) => {
        this.agentList = res.listMissingAgents as Agent[];
        if (this.agentList === null || this.agentList.length < 1) {
          this.router.navigate(['/manage-file/download-feedback']);
        } else {
          this.officeService.getOffices()
            .subscribe(offices => {
              this.offices = offices
            });
        }
      }, error => {
        console.log(error)
        this.router.navigate(['/']);
      });
  }

  onSubmit() {
    this.agentService.saveAgents(this.agentList)
      .subscribe((res: any) => { console.log(res) }, err => console.log(err));
    this.router.navigate(['/manage-file/download-feedback']);
  }

}
